import PropTypes from "prop-types";
import UIWidgetsButton from "./Button";
import ajaxLoader from "../../../../common/icons/ajax-loader.gif";

/**
 * Global style definition for all the button elements.
 */
export default function Button({ children, primary = false, showloader = false, disabled = false, padding, handleOnClick }) {
  const onClick = (e) => {
    e.preventDefault();
    if (handleOnClick) handleOnClick();
  };
  return (
    <UIWidgetsButton
      className="primary-button"
      primary={primary}
      padding={padding}
      onClick={onClick}
      showloader={showloader}
      disabled={disabled}
    >
      <img src={ajaxLoader} loading="lazy" alt="loader" />
      {children || ""}
    </UIWidgetsButton>
  );
}

Button.propTypes = {
  /** No user action on button is allowed */
  disabled: PropTypes.bool,
  /** Primary theme colour */
  primary: PropTypes.bool,
  /** Loading animation */
  showloader: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  handleOnClick: PropTypes.func
};
